import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "./pages/home";
import About from "./pages/aboutMe";
import Projects from "./pages/projects";
import Contact from "./pages/contactMe";
import Booth from "./pages/photobooth";
import SoftwareProjects from "./pages/softwarePro";
import HardwareProjects from "./pages/hardwarePro";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} /> 
        <Route path="/contact" element={<Contact />} />
        <Route path="/photobooth" element={<Booth />} />
        <Route path="/software-projects" element={<SoftwareProjects />}/>
        <Route path="/hardware-projects" element={<HardwareProjects />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;